import type { AboutWhyCreatedSettings } from '@/types/about-sections';
import { Button } from '../ui/Button';
import { Reveal } from '../motion/Reveal';

interface AboutWhyCreatedProps {
  settings: AboutWhyCreatedSettings;
}

export function AboutWhyCreated({ settings }: AboutWhyCreatedProps) {
  const paragraphs = settings.body
    ? settings.body.split('\n\n').filter(Boolean)
    : [];
  const mobileImg = settings.mobile_image_url || settings.image_url;

  return (
    <section className="relative w-full overflow-hidden bg-primary text-white">
      {mobileImg && (
        <></>
      )}

      {settings.image_url && (
        <div
          className="absolute inset-0 hidden bg-cover bg-[center_right] bg-no-repeat md:block"
          style={{ backgroundImage: `url("${settings.image_url}")` }}
          aria-hidden
        />
      )}

      <div className="relative z-10 mx-auto flex min-h-[28rem] w-full max-w-7xl items-center px-4 py-16 sm:px-6 md:min-h-[32rem] md:py-20 lg:min-h-[34rem] lg:py-24">
        <Reveal variant="slideInLeft" className="w-full max-w-xl lg:max-w-[55%]">
          {settings.eyebrow && (
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-white/80">
              {settings.eyebrow}
            </p>
          )}
          {settings.heading && (
            <h2 className="font-bold uppercase leading-[1.15] tracking-wide text-3xl md:text-4xl lg:text-[2.5rem]">
              {settings.heading}
            </h2>
          )}
          {paragraphs.length > 0 && (
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/90 md:text-[15px]">
              {paragraphs.map((para) => (
                <p key={para.slice(0, 32)}>{para}</p>
              ))}
            </div>
          )}
          {settings.button_label && (
            <div className="mt-8 max-md:flex max-md:justify-center">
              <Button
                href={settings.button_link || '#'}
                variant="inverse"
                className="!text-primary"
              >
                {settings.button_label}
              </Button>
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
